/**
 * 按实体类型打开它：有 flyout 的（task / intent / reservation）在当前页开 flyout；
 * 有自己页面的（review / listing / …，见 entityLinks.ENTITY_PAGES）在当前标签页跳过去；都不是 → 不处理（返回 false）。
 * 助手正文里的实体链接与写操作后的实体卡片共用这一个入口。
 * 在 Router / flyout 宿主之外（例如单独渲染的气泡）拿不到就返回 false，调用方照常处理链接。
 */
import { useCallback, useContext } from 'react'
import { UNSAFE_NavigationContext } from 'react-router-dom'
import { useEntityFlyout } from './EntityFlyoutProvider'
import { entityPagePath } from './entityLinks'

export function useOpenEntity(): (type: string, id: string) => boolean {
  const flyout = useEntityFlyout()
  // useNavigate 在 Router 外会抛；导航上下文在 Router 外是 null，这里只在有的时候用
  const navigator = useContext(UNSAFE_NavigationContext)?.navigator
  return useCallback((type: string, id: string) => {
    if (flyout?.canOpen(type)) {
      flyout.open(type, id)
      return true
    }
    const path = entityPagePath(type, id)
    if (path && navigator) {
      navigator.push(path)
      return true
    }
    return false
  }, [flyout, navigator])
}
